<template>

<w-flex wrap>
    <div class="xs12 mt5 text-left p5">Select IMEIs Labels</div>
    <w-divider class="my6 mx-3"></w-divider>
  </w-flex>
  <!-- <w-flex> -->
  <LabelsScroll class="xs12 mb10" @setlabel="setToAdd"></LabelsScroll>
  <!-- </w-flex> -->
  <InteractiveListComponent
    ref="labelToAdd"
    :disabled="false"
    :required="false"
    :list="labels"
    @removeFromList="removeLabel"
    @addToList="addLabel"
  />
</template>
<script>
//TODO convert add to basestation con store and remove nested variables with
import InteractiveListComponent from "@/modules/label-group/components/InteractiveListComponent.vue";

import LabelsScroll from "@/modules/label-group/components/LabelsScroll.vue";
import { computed, ref } from "vue";
export default {
  name: "AddLabels",
  components: {
    InteractiveListComponent,
    LabelsScroll,
  },
  props: {
    labelsList: Array,
  },
  emits: ["removeLabel", "addLabel"],
  setup: (props, { emit }) => {
    let labelToAdd = ref(null);
    let labels = computed(() => {
      if (!props.labelsList) {
        return [];
      }
      return props.labelsList.map((l) => {
        return { label: l, value: l };
      });
    });
    function removeLabel(e) {
      //   labels = labels.filter((i) => i.value != e);
      emit("removeLabel", e);
      //   labels=props.labelsList.map((l) => {
      //     return { label: l, value: l };
      //   });
    }
    function addLabel(e) {
      //   labels.push(e);
      emit("addLabel", e);
    }
    function setToAdd(label) {
      labelToAdd.value.toAddL(label);
    }
    // watch(props.labelsList, (newLabelsList) => {
    //   labels = newLabelsList.map((l) => {
    //     return { label: l, value: l };
    //   });
    // });

    return {
      labels,
      removeLabel,
      addLabel,
      setToAdd,
      labelToAdd,
    };
  },
};
</script>
